import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

interface LoginProps {
  isArabic?: boolean;
  isAdmin?: boolean;
}

export const Login: React.FC<LoginProps> = ({ isArabic = true, isAdmin = false }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    const success = login(username, password);
    if (!success) {
      setError(isArabic ? 'اسم المستخدم أو كلمة المرور غير صحيحة' : 'Invalid username or password');
    }
  };

  return (
    <div className={`login-container ${isArabic ? 'rtl' : 'ltr'}`}>
      <div className="login-card">
        <div className="login-header">
          <h2>{isAdmin ? (isArabic ? 'تسجيل دخول المدير' : 'Admin Login') : (isArabic ? 'تسجيل الدخول' : 'Login')}</h2>
          <p>{isArabic ? 'مرحباً بك في سند' : 'Welcome to Sanad'}</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>{isArabic ? 'اسم المستخدم' : 'Username'}</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>{isArabic ? 'كلمة المرور' : 'Password'}</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="login-button">
            {isArabic ? 'دخول' : 'Login'}
          </button>
        </form>

        <div className="login-demo-info">
          <p>{isArabic ? 'للتجربة:' : 'Demo Credentials:'}</p>
          <p><strong>{isArabic ? 'مستخدم عادي:' : 'User:'}</strong> user / user123</p>
          <p><strong>{isArabic ? 'مدير:' : 'Admin:'}</strong> admin / admin123</p>
        </div>
      </div>
    </div>
  );
};